import React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { Controller, useFormContext } from "react-hook-form";
// import { FormHelperText } from "@mui/material";

const filter = createFilterOptions();

function MultiSelectDropdown({
  setting,
  setParentState,
  styles = {},
  name,
  validations = {},
  disableCloseOnSelect = false,
}) {
  const {
    formState: { errors },
    setValue,
    trigger,
    control,
  } = useFormContext();

  const multiSelectDropdownRender = (field = {}) => (
    <Autocomplete
      {...field}
      multiple
      disableCloseOnSelect={disableCloseOnSelect}
      id={`multi-select-dropdown-${name}`}
      sx={{ width: "100%", marginBottom: "2rem", ...styles }}
      defaultValue={setting.field_value}
      onChange={(e, newValue) => {
        const parentStateValueToSet = Array.isArray(newValue) ? newValue : [newValue];

        // If we have seen it, due to behavior
        const filteredForDuplicates = Object.values(
          parentStateValueToSet.reduce((seen, selectedOption) => {
            if (!seen[selectedOption.value]) seen[selectedOption.value] = selectedOption;
            else delete seen[selectedOption.value];

            return seen;
          }, {})
        );

        setParentState(filteredForDuplicates);

        if (name) {
          setValue(name, filteredForDuplicates);
          trigger(name);
        }
      }}
      filterOptions={(options, params) => filter(options, params)}
      isOptionEqualToValue={(opt, value) => (value ? value === opt.display : true)}
      filterSelectedOptions={!!setting?.filterSelectedOptions}
      options={setting.options}
      groupBy={(option) => option.group}
      autoHighlight
      getOptionLabel={(option) => option?.display || ""}
      renderOption={(props, option) => (
        <MenuItem {...props} key={option.value} value={option}>
          <Checkbox
            checked={
              !!setting?.field_value?.find?.(
                (selectedOption) => selectedOption.value === option.value
              )
            }
          />
          <ListItemText primary={option.display} />
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={setting.en_field_label}
          inputProps={{
            ...params.inputProps,
          }}
          error={errors[name]?.message || false}
          helperText={errors[name]?.message}
        />
      )}
    />
  );

  return (
    <Box sx={{ width: "100%", ...styles }}>
      <FormControl sx={{ width: "100%" }}>
        {name ? (
          <Controller
            name={name}
            control={control}
            defaultValue={setting.field_value}
            rules={validations}
            render={({ field }) => multiSelectDropdownRender(field)}
          />
        ) : (
          multiSelectDropdownRender()
        )}
        {/* {errors[name]?.message ? (
          <FormHelperText style={{ color: "red" }}>{errors[name]?.message}</FormHelperText>
        ) : null} */}
      </FormControl>
    </Box>
  );
}

export default MultiSelectDropdown;
